define('presentation/account/sidebar/presentationObjects/statusChangedPresentationObject',[], function () {
    return function () {
        var self = this;
        self.statusName = null;
        self.statusChangeText = null;
        self.toStatus = null;
    };
});

